// Butiksmeddelande – glider in nere till höger, försvinner efter
// data-duration sekunder. Visas en gång per session (sessionStorage)
// och kan stängas manuellt via kryss-knappen.
(function () {
    const SESSION_KEY = 'lw_shopmsg_shown'
    const FADE_OUT_MS = 300

    document.addEventListener('DOMContentLoaded', () => {
        const el = document.querySelector('.lw-shopmsg')
        if (!el) return

        if (sessionStorage.getItem(SESSION_KEY) === '1') {
            el.remove()
            return
        }

        sessionStorage.setItem(SESSION_KEY, '1')

        const seconds = parseInt(el.dataset.duration, 10)
        const duration = (Number.isFinite(seconds) && seconds > 0 ? seconds : 5) * 1000

        let autoHideTimer = null

        const hide = () => {
            if (autoHideTimer) {
                clearTimeout(autoHideTimer)
                autoHideTimer = null
            }
            el.classList.remove('active')
            setTimeout(() => el.remove(), FADE_OUT_MS)
        }

        const progress = el.querySelector('.lw-shopmsg-progress')

        // Double rAF så CSS-transitionen hinner triggas
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                el.classList.add('active')
                if (progress) {
                    progress.style.transition = `transform ${duration}ms linear`
                    progress.style.transform = 'scaleX(0)'
                }
            })
        })

        autoHideTimer = setTimeout(hide, duration)

        const closeBtn = el.querySelector('.lw-shopmsg-close')
        if (closeBtn) {
            closeBtn.addEventListener('click', hide)
        }
    })
})()
